import {OauthService} from './oauth.service';
import {Subject} from 'rxjs/Subject';
import {Injectable} from '@angular/core';
import {Search} from '../models/search/search.model';
import {App} from 'ionic-angular';
import {Observable} from 'rxjs/Observable';
import {Http, URLSearchParams} from '@angular/http';
import {ToolsService} from './tools.service';
import { CeInterface } from '../models/ce/ce.interface';
import {AppProvider} from "../../core/app/app-provider.service";

@Injectable()
export class BlogArticleService extends OauthService {

  public loader = new Subject<boolean>();

  constructor(
    protected http: Http,
    protected app: App,
    protected appProvider: AppProvider,
    public readonly tools: ToolsService,
  ) {
    super(http, app, appProvider, tools);
    this.loader.next(true); // init custom loader
  }

  getAll(search: Observable<Search> = null) {
    return search.debounceTime(500)
      .distinctUntilChanged()
      .switchMap(s => this.searchAll(s, s.action));
  }

  getElus(search: Observable<Search> = null) {
    return search.debounceTime(500)
      .distinctUntilChanged()
      .switchMap(s => this.searchElus(s, s.action));
  }

  searchAll(search: Search, action: string) {
    const param = {'_format': 'json', 'clos': 0};

    for (const item in search) {
      if (search[item] !== null) {
        param[item] = search[item];
      }
    }

    const url = this.Routing.generate('api_get_blog-articles', param, true);
    return this.http
      .get(url, {headers: this.updateHeaders()})
      .map(response => {
        this.loader.next(false); // disable custom loader
        return {data: response.json().data, action};
      });
  }

  searchElus(search: Search, action: string) {
    const param = {'_format': 'json', 'clos': 0};

    for (const item in search) {
      if (search[item] !== null) {
        param[item] = search[item];
      }
    }

    const url = this.Routing.generate('api_cget_blog-articles_elus', param, true);
    return this.http
      .get(url, {headers: this.updateHeaders()})
      .map(response => {
        this.loader.next(false); // disable custom loader
        return {data: response.json().data, action};
      });
  }

  getBlogArticle(id: string) {
    const url = this.Routing.generate('api_get_blog-articles', {'_format': 'json', 'blogArticle': id}, true);
    return this.http
      // .get(`${url}/${id}`, {headers: this.updateHeaders()})
      .get(`${url}`, {headers: this.updateHeaders()})
      .map(response => {
        return response.json().data;
      });
  }

  getPreviousNext(id: string) {
    const url = this.Routing.generate('api_get_blog-articles_previous_next', {'_format': 'json', 'blogArtId': id}, true);
    return this.http
      .get(url, {headers: this.updateHeaders()})
      .map(response => {
        return response.json().data;
      });
  }

  getWebContainer() {
    const url = this.Routing.generate('api_get_webcontainers', {'_format': 'json'}, true);
    return this.http.get(`${url}`, {headers: this.updateHeaders()})
      .map(response => {
        return response.json().data;
      });
  }

  toggleLike(id: string) {
    const url = this.Routing.generate('api_post_blog-articles_toggle_like', {
      '_format': 'json',
      'blogArticle': id
    }, true);
    return this.http
      .post(url, '', {headers: this.updateHeaders()})
      .map(response => response.json());
  }

  toggleEmail(idBlogArticle: string, idBeneficiaire: string) {
    const url = this.Routing.generate('api_get_blog-articles_send_mail', {'_format': 'json'}, true);

    const params = new URLSearchParams();
    params.set('blogArticle', idBlogArticle);
    params.set('beneficiaire', idBeneficiaire);

    return this.http
      .get(url, {search: params, headers: this.updateHeaders()})
      .map(response => response.json());;

  }

  getPJ(id: string) {
    const url = this.Routing.generate('api_get_blog-articles_pj', {'_format': 'json', 'blogArticle': id}, true);
    return this.http
      .get(`${url}`, {headers: this.updateHeaders()})
      .map(response => {
        return response.json().data;
      });
  }

  getLinkBilletterie(): string {
    const token: string = this.tools.localStorageService.getOauthToken().access_token;
    const ce: CeInterface = this.tools.localStorageService.getCe();
    const url: string = this.Routing.generate('api_get_blog-articles_billetterie', { '_format': 'json', 'a': token, 'b': ce.code }, true);
    return url;
  }
}



// WEBPACK FOOTER //
// ./src/shared/services/blogArticle.service.ts